import { useState, useContext } from 'react'
import cx from 'classnames'

import { SanityBlogPostGrid } from '@data/sanity/queries/types/modules'
import { StringsContext } from '@lib/strings'

import Button, { ButtonVariant } from '@components/buttons/button'
import BlogPostCard from '@blocks/blog/blog-post-card'

type BlogPostGridProps = SanityBlogPostGrid

const BlogPostGrid = ({ posts, options, postsPerRow }: BlogPostGridProps) => {
  const paginationLimit = postsPerRow === 4 ? 12 : 9

  const strings = useContext(StringsContext)

  const [pagination, setPagination] = useState([
    ...posts.slice(0, paginationLimit),
  ])

  const [hasMore, setHasMore] = useState(
    posts && posts.length > paginationLimit
  )

  if (!posts.length) {
    return null
  }

  const hasPagination = paginationLimit > 0
  const postsList = hasPagination ? pagination : posts

  const loadMore = () => {
    const curPage = pagination.length
    const nextPage = posts.slice(curPage, curPage + paginationLimit)
    const newPage = [...pagination, ...nextPage]

    if (hasMore) {
      setPagination(newPage)
      setHasMore(newPage.length < posts.length)
    }
  }

  return (
    <section className="container">
      <div
        className={cx(
          `grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${
            postsPerRow ?? 3
          } gap-10 mb-20`
        )}
      >
        {postsList.map((post) => (
          <BlogPostCard
            key={`post-${post.slug}`}
            post={post}
            options={options}
          />
        ))}
      </div>

      {hasPagination && hasMore && (
        <div className="relative py-4 sm:py-8 text-center">
          {hasMore && (
            <Button onClick={loadMore} variant={ButtonVariant.FILLED}>
              {strings.buttonLoadMore}
            </Button>
          )}
        </div>
      )}
    </section>
  )
}

export default BlogPostGrid
